import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {getColor} from "helpers/chartcolors"; // Importing getColor function from helpers module

/**
 * MoneyView class extends JetView to create a chart view for displaying user money statistics.
 */
export default class MoneyView extends JetView {
	/**
	 * Configures the layout of the MoneyView.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for translating text
		return {
			type:"clean", // Clean layout type
			rows:[
				{ 
					template:_("Top Usuarios"), // Header template with localized text
					type:"header", 
					css:"webix_header chart_header" // CSS class for styling the header
				},
				{
					view:"chart", // Chart view configuration
					type:"bar", // Bar chart type
					localId:"chart", // Local ID for referencing the chart
					border:false, // No border around the chart
					radius:0, // No rounded corners
					color:() => getColor(), // Dynamic color fetching for bars
					barWidth:24, // Width of each bar in the chart
					padding:{
						top:5, // Padding on top of the chart
						left:60 // Padding on the left of the chart
					},
					value:"#money#", // Data field for the bar value
					xAxis:{
						template:"#user#", // Template for x-axis labels
						lines:false, // No lines on the x-axis
						color:"#EDEFF0", // Color of the x-axis
						title:"Usuario" // Title for the x-axis
					},
					yAxis:{
						start:0, // Starting point for y-axis
						step:100, // Step value for y-axis ticks
						color:"#fff", // Color of the y-axis labels
						lineColor:"#EDEFF0", // Color of the y-axis line
						title:"Saldo" // Title for the y-axis
					},
					tooltip:{
						template:"<b>#fname# #lname#</b><br>$#money#" // Tooltip template for displaying user info and money
					}
				}
			]
		};
	}

	/**
	 * Initializes the MoneyView and sets up event listeners.
	 */
	init(){
		const cur_user = this.getParam("user", true); // Fetches the current user parameter from the URL
		var vthis = this; // Reference to the current instance of MoneyView
		this.on(this.app,"statisticsAgent:MoneyUsers",data => { // Event listener for MoneyUsers statistics
			vthis.$$("chart").clearAll(); // Clears existing chart data
			vthis.$$("chart").parse(data); // Parses new data into the chart
		});
	}
}

// FILE DOCUMENTED
